<p-drawer 
    [header]="dialogHeader()" 
    (onHide)="closeDialog()" 
    (visible)="isDialogVisible.set(false)"
    [visible]="isDialogVisible()"
    position="right" 
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    
    <spike-organization-form 
        [formView]="isFormView()"
        [form]="fixedForm()" 
        [entityEtiquetteList]="entityEtiquetteList()"
        [etiquette]="etiquette()">
    </spike-organization-form>

    @if(entityModelFields()){
    <spike-model-dynamic-form
        [form]="dynamicForm()" 
        [entityModelFields]="entityModelFields()">
    </spike-model-dynamic-form>
    }

    @if(entityApi() == entityApiEnum.OPERATION){
        <div class="mt-2  mb-4">
            <spike-label label="Macchine"></spike-label>
            @for(machine of machineListShowed(); track $index){
                <div class="mb-2 ml-1">
                    <p-checkbox [(ngModel)]="machine.selected" [binary]="true" [inputId]="machine.shortDescription + '_'+$index" [value]="machine.shortDescription" [disabled]="!isFormView()" />
                    <label [for]="machine.shortDescription + '_'+$index" class="ml-2"> {{machine.shortDescription}} </label>

                </div>
            }
        </div>
        <div class="mt-2">
            <spike-label label="Dipendenti"></spike-label>
             @for(employee of employeeListShowed(); track $index){
                <div class="mb-2 ml-1">
                    <p-checkbox [(ngModel)]="employee.selected" [binary]="true" [inputId]="employee.shortDescription + '_'+$index" [value]="employee.shortDescription" [disabled]="!isFormView()" />
                    <label [for]="employee.shortDescription + '_'+$index" class="ml-2"> {{employee.shortDescription}} </label>

                </div>
            }
        </div>
    }

    <ng-template #footer>
        <div class="flex gap-4 w-full justify-between">
        @if(isFormView()){

            <div class="flex gap-2 w-full justify-end">
                <p-button 
                    (click)="onSaveClicked()" 
                    [disabled]="dynamicForm().invalid || fixedForm().invalid" 
                    icon="pi pi-save" 
                    label="Salva"
                    severity="primary"
                    class="w-full"
                    styleClass="w-full">
                </p-button>

            </div>
            <div class="flex gap-2">
                <p-button [disabled]="!!!dataId()" (click)="isFormView.set(false)" icon="pi pi-times" severity="secondary" [outlined]="true"></p-button>
            </div>
        } @else {
                <div class="flex gap-2">
                    @if(dataId() && freshData().stateId==1){
                        <p-button (click)="onDeleteClicked()" icon="pi pi-trash" severity="danger" [outlined]="true"></p-button>
                    }
                </div>
                @if(dataId() && freshData().stateId==1){

                    <div class="flex gap-2 w-full justify-end">
                        <p-button 
                            class="w-full"
                            styleClass="w-full"
                            (click)="isFormView.set(true)" 
                            icon="pi pi-pencil" 
                            label="Modifica"
                            severity="secondary">
                        </p-button>
                        
                    </div>
                }@else{
                    <div class="flex gap-2 w-full justify-end">
                        <p-button 
                            class="w-full"
                            styleClass="w-full"
                            (click)="onRestoreClicked()" 
                            icon="pi pi-pencil" 
                            label="Ripristina"
                            severity="primary">
                        </p-button>
                        
                    </div>
                }
        }
        </div>
    </ng-template>
</p-drawer>
